import {
  ContentEntity,
} from './contentEntity';
import { Category } from './valueObjects/category';
import { ContentAttachment } from './valueObjects/contentAttachment';
import { ContentS3Path } from './valueObjects/contentS3Path';
import { Title } from './valueObjects/title';

import type {
  ContentProps,
} from './contentEntity';
import type { ContentJson } from '@/types/domain/notice/entities/contentEntity';

import { Factory } from '@/domain/factory';

/**
 * コンテンツファクトリ
 */
export class ContentFactory extends Factory<
  ContentEntity,
  ContentProps,
  ContentJson
> {
  /**
   * 比較
   * @param a 対象1
   * @param b 対象2
   * @returns 差分
   */
  comparePvt = (a: ContentJson, b: ContentJson) => a.s3Path.localeCompare(b.s3Path, 'en');

  /**
   * Entityを生成する
   * @param props プロパティ
   * @returns Entity
   */
  createPvt(props: ContentProps): ContentEntity {
    return new ContentEntity(props, null);
  }

  /**
   * JsonからEntityを生成する
   * @param props Json
   * @returns Entity
   */
  createFromJsonPvt(props: ContentJson): ContentEntity {
    return this.createPvt({
      s3Path: ContentS3Path.create(props.s3Path),
      category: Category.create(props.category),
      title: Title.create(props.title),
      attachment: ContentAttachment.create(props.attachment),
    });
  }
}
